module.exports = __webpack_public_path__ + "static/img/advertisingSpace.41824bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advertisingSpace.png
// module id = 6LSM
// module chunks = 1